import React, { Children, Component } from 'react';
import { motion } from 'framer-motion';
import { RocketIcon, TargetIcon, TrendingUpIcon, ZapIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
const features = [{
  icon: TargetIcon,
  title: 'Segmentación Precisa',
  description: 'Aprende a encontrar y llegar exactamente a tu cliente ideal.'
}, {
  icon: ZapIcon,
  title: 'Resultados Rápidos',
  description: 'Estrategias probadas para ver resultados desde la primera semana.'
}, {
  icon: TrendingUpIcon,
  title: 'Escalable',
  description: 'Técnicas que funcionan si inviertes $5 o $5,000 al día.'
}, {
  icon: RocketIcon,
  title: 'Paso a Paso',
  description: 'Sin tecnicismos. Explicado para que cualquiera pueda seguirlo.'
}];
export function SolutionSection() {
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-168">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-169">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} data-id="element-170">
          {/* Section header */}
          <motion.div variants={itemVariants} className="mb-16 text-center" data-id="element-171">
            <span className="mb-4 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-electric-blue/10 to-bright-orange/10 px-4 py-2 text-sm font-semibold text-electric-blue" data-id="element-172">
              <RocketIcon className="h-4 w-4" data-id="element-173" />
              La solución
            </span>
            <h2 className="mb-6 font-heading text-3xl font-extrabold text-gray-900 sm:text-4xl md:text-5xl" data-id="element-174">
              Convierte Meta Ads en clientes reales por WhatsApp
            </h2>
            <p className="mx-auto max-w-3xl text-lg text-gray-600 sm:text-xl" data-id="element-175">
              Un curso diseñado para emprendedores que quieren generar
              conversaciones reales en WhatsApp usando Facebook e Instagram,
              incluso sin experiencia previa.
            </p>
          </motion.div>

          {/* Features grid */}
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-176">
            {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return <motion.div key={index} variants={itemVariants} className="text-center" data-id="element-177">
                  <div className="mx-auto mb-4 inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-electric-blue to-bright-orange shadow-lg" data-id="element-178">
                    <IconComponent className="h-8 w-8 text-white" data-id="element-179" />
                  </div>
                  <h3 className="mb-2 font-heading text-lg font-bold text-gray-900" data-id="element-180">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-181">{feature.description}</p>
                </motion.div>;
          })}
          </div>

          {/* Highlight box */}
          <motion.div variants={itemVariants} className="mt-16 overflow-hidden rounded-3xl bg-gradient-to-r from-electric-blue to-bright-orange p-1" data-id="element-182">
            <div className="rounded-[22px] bg-white p-8 text-center sm:p-12" data-id="element-183">
              <h3 className="mb-4 font-heading text-2xl font-bold text-gray-900 sm:text-3xl" data-id="element-184">
                De cero a tu primer cliente por WhatsApp
              </h3>
              <p className="mx-auto max-w-2xl text-lg text-gray-600" data-id="element-185">
                No importa si nunca has creado un anuncio. Este curso te guía
                paso a paso para activar tu sistema de clientes en WhatsApp
                usando Meta Ads.
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}